import { render, staticRenderFns } from "./WoundCreate.vue?vue&type=template&id=b58fb7ac&"
import script from "./WoundCreate.vue?vue&type=script&lang=js&"
export * from "./WoundCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports